<template>
  <div class="calico-card-page">
    <div class="calico-card-container">
      <div class="calico-card-row">
        <div style="width: 500px;">
          <CalicoBusinessInfo 
            :info="info"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import CalicoBusinessInfo from '@/components/calico/businessInfo/index.vue';
  
  export default {
    name: 'CalicoBusinessInfoPage',
    components: {
        CalicoBusinessInfo,
    },
    data() {
      return {
        info: {
          name: "Betty's Place",
          addressLine1: "5916 1/2 N Figueroa St",
          addressLine2: "Los Angeles, CA 90042",
          category: "New American Restaurant",
          website: "www.bettysplace.com",
          phone: "(323) 545-3536"
        }
      };
    },
  };
  </script>
  
  <style lang="scss">
  .calico-card-page {
    display: flex;
    justify-content: center;
    align-items: center;
    .calico-card-container {
      @include stack-space($space-large);
      @include inset-space($space-large);
      width: 100%;
      .calico-card-row {
        @include inline-space($space-large);
        @include inset-space($space-large);
      }
    }
  }
  </style>